import { useLocation } from 'react-router-dom';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped dep
import IFrame from 'ui-addon-iframeable/host/IFrame';
import { IframeLayout } from '../components/layouts/IframeLayout';
import { useIsMobileView } from '../hooks/useWindowSize';
import { ROUTES } from '../components/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function UpdatePaymentMethod() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const updatePaymentUrl = params.get('url');
  const isMobileView = useIsMobileView();
  return /*#__PURE__*/_jsx(IframeLayout, {
    backButtonMessage: "updatePaymentMethod.backButton",
    breadcrumbs: [{
      label: 'updatePaymentMethod.breadcrumb.billing',
      href: ROUTES.billing
    }, {
      label: 'updatePaymentMethod.breadcrumb.updatePaymentMethod'
    }],
    subscreen: "update-payment-method",
    children: updatePaymentUrl && /*#__PURE__*/_jsxs(View, {
      marginInline: isMobileView ? '0' : '1400',
      paddingBlockStart: "1000",
      paddingBlockEnd: isMobileView ? '1000' : '1500',
      children: [/*#__PURE__*/_jsx(Text, {
        marginInlineStart: "800",
        typography: "heading-600",
        marginBlockEnd: "800",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "updatePaymentMethod.title"
        })
      }), /*#__PURE__*/_jsx(IFrame, {
        src: updatePaymentUrl,
        onReady: () => {},
        iframePassthruProps: {
          style: {
            border: 'none',
            marginInline: isMobileView ? '0' : '5%',
            width: isMobileView ? '100%' : '90%',
            height: 'calc(100vh - 400px)'
          },
          title: 'Update Payment Method'
        }
      })]
    })
  });
}